<thm-input-text [inputId]="inputId" [inputWidth]="inputWidth" [labelText]="labelText" 
    [placeholder]="placeholder" [helperText]="helperText" [inputName]="inputName" 
    [inputId]="inputId" [inputSize]="inputSize" [readonly]="readonly" [horizontal]="horizontal" 
    [model]="model" [wasValidated]="wasValidated" [errors]="errors" [isPassword]="isPassword" 
    (modelChange)="onChange($event)" class="remove-margin"    > 
</thm-input-text> 